/**
 * Remoting XPAC API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DeploymentDeviceStatus = 'unknown' | 'failure' | 'aborted' | 'pauseBeforeInstalling' | 'pauseBeforeCommitting' | 'pauseBeforeRebooting' | 'downloading' | 'installing' | 'rebooting' | 'pending' | 'success' | 'noArtifact' | 'alreadyInstalled' | 'decommissioned';

export const DeploymentDeviceStatus = {
    Unknown: 'unknown' as DeploymentDeviceStatus,
    Failure: 'failure' as DeploymentDeviceStatus,
    Aborted: 'aborted' as DeploymentDeviceStatus,
    PauseBeforeInstalling: 'pauseBeforeInstalling' as DeploymentDeviceStatus,
    PauseBeforeCommitting: 'pauseBeforeCommitting' as DeploymentDeviceStatus,
    PauseBeforeRebooting: 'pauseBeforeRebooting' as DeploymentDeviceStatus,
    Downloading: 'downloading' as DeploymentDeviceStatus,
    Installing: 'installing' as DeploymentDeviceStatus,
    Rebooting: 'rebooting' as DeploymentDeviceStatus,
    Pending: 'pending' as DeploymentDeviceStatus,
    Success: 'success' as DeploymentDeviceStatus,
    NoArtifact: 'noArtifact' as DeploymentDeviceStatus,
    AlreadyInstalled: 'alreadyInstalled' as DeploymentDeviceStatus,
    Decommissioned: 'decommissioned' as DeploymentDeviceStatus
};

